import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Text, Image, TextInput } from 'grommet'
import styled from 'styled-components'
import Arrow from '../../images/rng/arrow.svg'
import {
  setChoices,
  setMinValueStore,
  setMaxValueStore,
  setIntervalValueStore,
  setExcludeFieldValue,
} from '../../redux/rng/actions'
import { device } from '../../theme/device'
import { isMobileOnly } from 'react-device-detect'
// import { useDarkMode } from '../../contextHook/darkMode'

const Container = styled(Box)`
  width: 100%;
`

const InputBox = styled(Box)`
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  border-radius: 2rem;
  justify-content: space-between;
  flex: 0 0 34%;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: ${props => props.theme.global.colors.baseBackground};
  /* width: 18rem; */
`

const IntervalBox = styled(Box)`
  flex: 0 0 28%;
  padding: 1.5rem 0.5rem;
  /* border-radius: 1.5rem; */
  background-color: ${props => props.theme.global.colors.baseBackground};
  /* width: 14rem; */
`

const MinMaxText = styled(TextInput)`
  font-size: 4.4rem;
  font-weight: 700;
  color: ${props => props.color};
  text-align: center;
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield;
  /* &:focus {
    border-color: ${props => props.theme.global.colors.focus};
    outline-color: ${props => props.theme.global.colors.focus};
  } */
  @media ${device.medium} {
    font-size: 3.6rem;
  }
`

const IntervalText = styled(TextInput)`
  font-size: 2.8rem;
  font-weight: 700;
  color: ${props => props.color};
  text-align: center;
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield;
  /* &:focus {
    border-color: ${props => props.theme.global.colors.focus};
    outline-color: ${props => props.theme.global.colors.focus};
  } */
`

const ArrowImage = styled(Image)`
  /* margin-bottom: 0rem; */
`

const RangeInputBox = styled(Box)`
  height: 15rem;

  @media ${device.medium} {
    height: 13rem;
  }
`

const Input = ({
  // min = 1,
  // max = 10,
  // interval = 1,
  rangeInputInit,
  setInitDone,
}) => {
  // const toolColorsPersist = useSelector(
  //   state => state.settings.wheelColors.colors,
  // )
  // const [toolColors, setToolColors] = useState(['', '', '', ''])
  const minValue = useSelector(state => state.rng.minValue) //add initialization for fullscreen purpose
  const maxValue = useSelector(state => state.rng.maxValue)
  const intervalValue = useSelector(state => state.rng.intervalValue)
  const excludeFieldValue = useSelector(state => state.rng.excludeFieldValue)
  const [excludeValues, setExcludeValues] = useState([])
  const pastValues = useRef({
    minValue,
    maxValue,
    intervalValue,
  })
  // const { value: darkMode } = useDarkMode()
  const timeOutId = useRef(null)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   setToolColors(toolColorsPersist)
  // }, [toolColorsPersist])

  useEffect(() => {
    if (rangeInputInit) {
      if (timeOutId.current) {
        clearTimeout(timeOutId.current)
      }
      timeOutId.current = setTimeout(() => wheelChange(), 150)
    } else {
      //to let the wheel init immediately
      processExcludeValue(excludeFieldValue)
      wheelChange()
      setInitDone()
    }
  }, [minValue, maxValue, intervalValue, excludeValues])

  useEffect(() => {
    processExcludeValue(excludeFieldValue)
  }, [excludeFieldValue]) // need to useeeffect because to detect replace state also

  useEffect(() => {
    //clear timer
    return () => {
      clearTimeout(timeOutId.current)
    }
  }, [])

  const wheelChange = () => {
    if (minValue === '' || maxValue === '' || intervalValue === '') return
    let choices = []
    const numPortions = (maxValue - minValue) / intervalValue + 1
    const maxLimit = isMobileOnly ? 500 : 1000
    if (numPortions <= maxLimit) {
      for (let i = minValue; i <= maxValue; i += intervalValue) {
        if (excludeValues.length > 0) {
          if (excludeValues.includes(i)) continue
        }
        choices.push(i)
      }
      pastValues.current = {
        minValue,
        maxValue,
        intervalValue,
      }
    } else {
      dispatch(setMinValueStore(pastValues.current.minValue))
      dispatch(setMaxValueStore(pastValues.current.maxValue))
      dispatch(setIntervalValueStore(pastValues.current.intervalValue))
    }
    dispatch(setChoices(choices))
  }

  const valueChanged = (event, type) => {
    let finalValue = event.target.value
    if (finalValue !== '') {
      finalValue = parseInt(finalValue)
    }
    switch (type) {
      case 'min':
        // setMinValue(finalValue)
        dispatch(setMinValueStore(finalValue))
        break
      case 'max':
        // setMaxValue(finalValue)
        dispatch(setMaxValueStore(finalValue))
        break
      case 'interval':
        // setIntervalValue(finalValue)
        dispatch(setIntervalValueStore(finalValue))
        break
    }
  }

  const excludeFieldChanged = event => {
    const oriValue = event.target.value
    dispatch(setExcludeFieldValue(oriValue))
  }

  const processExcludeValue = oriValue => {
    const value = oriValue.replace(/\s/g, '')
    // if (value === '') return
    const numberArray = value
      .split(',')
      .filter(el => el.length && el == +el)
      .map(Number)
    const numberSet = [...new Set(numberArray)]
    if (JSON.stringify(numberSet) !== JSON.stringify(excludeValues)) {
      setExcludeValues(numberSet)
    }
  }

  return (
    <Container align="stretch" gap=".5rem">
      <Text>Range: </Text>
      <RangeInputBox
        direction="row"
        // gap={size === "medium" ? ".7rem" : "1rem"}
        justify="between"
      >
        <InputBox>
          <Text> </Text>
          {rangeInputInit ? (
            <MinMaxText
              // type="number"
              focusIndicator={false}
              color="inputDarkLight"
              // {
              //   !darkMode || toolColors.length < 3
              //     ? toolColors[0]
              //     : toolColors[2]
              // }
              onChange={event => valueChanged(event, 'min')}
              value={minValue}
            />
          ) : (
            <MinMaxText />
          )}
          <Text weight="bold" truncate>
            MIN
          </Text>
        </InputBox>
        <IntervalBox justify="center" gap="0.3rem" alignSelf="center">
          <Box justify="center" direction="row" gap="2px" align="center">
            ({' '}
            {rangeInputInit ? (
              <IntervalText
                // type="number"
                color="inputDarkLight"
                // {
                //   !darkMode || toolColors.length < 3
                //     ? toolColors[0]
                //     : toolColors[2]
                // }
                onChange={event => valueChanged(event, 'interval')}
                value={intervalValue}
              />
            ) : (
              <IntervalText />
            )}{' '}
            )
          </Box>
          <ArrowImage src={Arrow} alt="arrow" />
          <Text weight="bold" textAlign="center" truncate>
            INTERVAL
          </Text>
        </IntervalBox>
        <InputBox>
          <Text> </Text>
          {rangeInputInit ? (
            <MinMaxText
              // type="number"
              color="inputDarkLight"
              // {
              //   !darkMode || toolColors.length < 3
              //     ? toolColors[0]
              //     : toolColors[2]
              // }
              onChange={event => valueChanged(event, 'max')}
              value={maxValue}
            />
          ) : (
            <MinMaxText />
          )}
          <Text weight="bold" truncate>
            MAX
          </Text>
        </InputBox>
      </RangeInputBox>
      <Text alignSelf="center" size="1.5rem">
        *Maximum {isMobileOnly ? 500 : 1000} Portions
      </Text>
      <Box margin={{ top: '1rem' }}>
        <Box
          direction="row"
          align="center"
          background="secondaryBg"
          pad={{ horizontal: '1rem' }}
          // round=".5rem"
        >
          <Text>Exclude:</Text>
          <TextInput
            plain
            value={excludeFieldValue}
            onChange={excludeFieldChanged}
            placeholder="E.g. 2,5,8"
          />
        </Box>
        <Text size="1.2rem">
          * Numbers to be excluded (separated by comma ,)
        </Text>
      </Box>
    </Container>
  )
}

export default Input
